"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shadowKeyUmbraOpacity = 0.15;
const shadowKeyPenumbraOpacity = 0.1;
const shadowAmbientShadowOpacity = 0.05;
function createShadow(px0, px1, px2, px3, px4, px5, px6, px7, px8, px9, px10, px11) {
    return [
        `${px0}px ${px1}px ${px2}px ${px3}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,
        `${px4}px ${px5}px ${px6}px ${px7}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,
        `${px8}px ${px9}px ${px10}px ${px11}px rgba(0,0,0,${shadowAmbientShadowOpacity})`,
    ].join(',');
}
exports.createShadow = createShadow;
exports.defaultShadows = [
    'none',
    createShadow(0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 2, -1),
    createShadow(0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 2, 1),
    createShadow(0, 0, 0, 0, 0, 6, 6, 0, 3, 1, 12, 1),
    createShadow(0, 0, 0, 0, 0, 0, 12, 1, 0, 0, 0, 0),
    createShadow(0, 0, 0, 0, 0, 0, 3, -1, 0, 2, 3, 1),
];
